var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-price",class:{ 'has-discount': _vm.hasDiscount },style:(_vm.fontSizeStyle)},[_c('p',[_vm._v("from")]),_c('p',{staticClass:"price-tag"},[_vm._v(_vm._s(_vm.formattedPrice))]),(_vm.hasDiscount)?_c('p',{staticClass:"discount-price"},[_vm._v(_vm._s(_vm.formattedDiscountPrice))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }